import { createSelector } from '@reduxjs/toolkit';

import { offerDataSelector } from './offerDataSelector';
import { getParent } from '../../utils/offer_helpers';

export const selectParent = createSelector([offerDataSelector], offerData => getParent(offerData));
